module.exports = __webpack_public_path__ + "static/media/japanqueennores.4e5b6b32.png";